import { useQuery } from '@tanstack/react-query';

import { useLanguage } from '@providers/LanguageProvider';

export const useLangQuery = options => {
  const { lang } = useLanguage();

  return useQuery({
    ...options,
    queryKey: Array.isArray(options.queryKey)
      ? [...options.queryKey, lang]
      : [options.queryKey, lang],
  });
};
